import React from "react";
import { TableHeaderProps } from "../../types";

export const PrayerTableHeader = React.memo(({
  headers,
  backgroundColor,
  color,
  renderCell,
  headerKey
}: TableHeaderProps) => (
  <tr key={headerKey} style={{ backgroundColor, color }}>
    {headers.map((header, i) => renderCell(header, `header-${i}`))}
  </tr>
));